import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';

import { isDevelopment, retry } from 'src/utils';

import { postFacebookEventV2 } from '@features/Analytics/api/facebook';
import type { TpFacebookParameters } from '@features/Analytics/types';

export const useFacebookEvent = () => {
  const externalId = Cookies.get('extId');
  const fbp = Cookies.get('_fbp');

  const { mutateAsync: postEventV2 } = useMutation({
    mutationFn: postFacebookEventV2,
    mutationKey: ['post-facebook-event-v2'],
  });

  const conditionCheckFunction = useCallback(
    async () =>
      // @ts-ignore
      window?.fbq != null,
    [],
  );

  const fetchClientEventWithRetry = useCallback(
    async ({ eventName, options, customData }: TpFacebookParameters) => {
      const isCustomEvent = eventName === 'SecondScreen';

      console.log(options);
      console.log(customData);

      const eventId = `${eventName}.${fbp}`;
      const actionFunction = async () => {
        // @ts-ignore
        window?.fbq?.(
          isCustomEvent ? 'trackCustom' : 'track',
          eventName,
          { ...options, ...customData },
          {
            eventID: eventId,
            extern_id: externalId,
          },
        );
      };

      await retry({
        conditionCheckFunction,
        actionFunction,
        retryDelay: 500,
      });

      if (!isDevelopment) {
        await postEventV2({
          eventId,
          eventName,
          fbp: fbp ?? '',
          options,
          customData,
          ...(externalId != null && { externalId }),
        });
      }
    },
    [conditionCheckFunction, externalId, fbp, postEventV2],
  );

  return useMemo(
    () => ({
      clientEvent: ({
        eventName,
        options,
        customData,
      }: TpFacebookParameters) => {
        fbp &&
          fetchClientEventWithRetry({
            eventName,
            options,
            customData,
          });
      },
    }),
    [fbp, fetchClientEventWithRetry],
  );
};
